import axios from 'axios';

// Base URL for API
// Use environment variable or default to local functions emulator
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://us-central1-kiranashop-77.cloudfunctions.net/api';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: API_BASE_URL
  // Content-Type will be set conditionally in the request interceptor
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Only set Content-Type for non-FormData requests
    // FormData will automatically set the correct Content-Type with boundary
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      // Server responded with error
      console.error('API Error:', error.response.data);
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // Request made but no response
      console.error('Network Error:', error.request);
      return Promise.reject({ error: 'Network error' });
    } else {
      // Something else happened
      console.error('Error:', error.message);
      return Promise.reject({ error: error.message });
    }
  }
);

export default apiClient;
